import { useRouter } from 'next/router'

import toast from 'react-hot-toast'
import { useSelector } from 'react-redux'
import { getFormValues } from 'redux-form'

import EmpriseGroup from '~/services/EmpriseGroup'
import { useGetUserListingQuery } from '~/services/Query/account/account.query'
import ErrorHandler from '~/utils/errorHandler'
import { getFormattedListingStepData } from '~/utils/functions'

import { LISTING_FORM_STEP_NAMES } from '~/constants'
import { Listing } from '~/models/Listing/interface'

const useCreateListing = ({ store, setStore, formStep, stepTitles }) => {
  const router = useRouter()
  const values = useSelector<any, Partial<Listing>>(
    getFormValues('Listing_Creation_Form')
  )
  const valuesEdit = useSelector<any, Partial<Listing>>(
    getFormValues('Listing_Edit_Form')
  )

  const { data: listing } = useGetUserListingQuery({
    id: router?.query?.id,
    options: {
      refetchOnWindowFocus: false,
      enabled: !!router?.query?.id,
      onError: () => router.replace('/')
    }
  })

  const onDraftListing = async (step?: number) => {
    setStore((state) => ({ ...state, loading: true }))
    const listingId = store?.subject_id || router?.query.id

    const currentStep = step || formStep
    const listingStepDto = getFormattedListingStepData(currentStep, stepTitles)

    const { images, ...listingValues } = values || valuesEdit
    const isFromImagesStep =
      listingStepDto.creation_step_name === LISTING_FORM_STEP_NAMES.video

    try {
      if (listingId) {
        await EmpriseGroup.updateListing(listingId, {
          ...listingValues,
          ...(isFromImagesStep && { images }),
          ...(!listing?.creation_completed && { creation_completed: false }),
          ...listingStepDto
        })

        return toast.success('Listing has been updated')
      }
      const { data } = await EmpriseGroup.createListing({
        ...values,
        creation_completed: false,
        ...listingStepDto
      })

      toast.success('Listing has been saved to your profile')
      setStore({ subject_id: data.id })
    } catch (error) {
      throw new ErrorHandler(error)
    } finally {
      setStore((state) => ({
        ...state,
        loading: false,
        completed: false
      }))
    }
  }

  return { onDraftListing }
}

export default useCreateListing
